import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../lib/auth.jsx';

/**
 * Gates every authenticated route.
 *
 * Nothing behind this renders until `status` has resolved past 'checking' —
 * that's what stops a page's first data fetch from racing the silent session
 * restore that runs in AuthProvider on mount (see lib/auth.jsx).
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-bg">
        <Loader2 size={24} className="animate-spin text-muted" aria-hidden="true" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
